import type { GetProps } from "antd";
import { Typography } from "antd";
import type { FC } from "react";

export type IotTypographyParagraphProp = GetProps<typeof Typography.Paragraph>;

export const IotTypographyParagraph: FC<IotTypographyParagraphProp> = (
    props,
) => <Typography.Paragraph {...props} />;
